import logo from "../images/logo.svg";

const Logo = () => {
    return (
        <>
            <div>
                <img src={logo} alt="sunnyside landing page" />
            </div>
        </>
    )
}

export default Logo
